// src/components/VideoPlayer.tsx

import React, { RefObject } from 'react'
import PanelContent from '../Panels'
import { ReactComponent as CloseIcon } from '../assets/icons/close.svg'
import { ACTION_TYPES, PANEL_VARIANTS, TIMING_CONSTANTS, AVATARS } from '../constants'
import { videos } from '../videoConfig'

const { CONTROL_BAR_HEIGHT } = TIMING_CONSTANTS

interface VideoPlayerProps {
  videoRef: RefObject<HTMLVideoElement>
  sourceRef: RefObject<HTMLSourceElement>
  currentIndex: number
  showHover: boolean
  showLinkOverlay: boolean
  linkUrl: string | null
  showPanel: boolean
  showPanelButton: boolean
  panelData: string | null
  onEnded: () => void
  onLoadedData: () => void
  onAvatarSelect: (avatar: string) => void
  onPanelToggle: () => void
  onPanelClose: () => void
}

export default function VideoPlayer({
  videoRef,
  sourceRef,
  currentIndex,
  showHover,
  showLinkOverlay,
  linkUrl,
  showPanel,
  showPanelButton,
  panelData,
  onEnded,
  onLoadedData,
  onAvatarSelect,
  onPanelToggle,
  onPanelClose,
}: VideoPlayerProps) {
  const currentVideo = videos[currentIndex]

  const handleRobertClick = () => {
    try {
      videoRef.current && videoRef.current.pause()
    } catch (e) {
      console.error('Error pausing video:', e)
    }
    onAvatarSelect(AVATARS.ROBERT)
  }

  const handleSilvieClick = () => {
    try {
      videoRef.current && videoRef.current.pause()
    } catch (e) {
      console.error('Error pausing video:', e)
    }
    onAvatarSelect(AVATARS.SILVIE)
  }

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: `calc(100svh - ${CONTROL_BAR_HEIGHT}px)`,
        overflow: 'hidden',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      <video
        ref={videoRef}
        preload="auto"
        playsInline
        onEnded={onEnded}
        onLoadedData={onLoadedData}
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
      >
        <source ref={sourceRef} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Avatar Selection Hover Overlays */}
      {showHover && (
        <>
          <div
            className="robertHover avatarHover"
            onClick={handleRobertClick}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '50%',
              height: '100%',
              opacity: 1,
              transition: 'opacity 0.3s ease',
            }}
          />
          <div
            className="silvieHover avatarHover"
            onClick={handleSilvieClick}
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              width: '50%',
              height: '100%',
              opacity: 1,
              transition: 'opacity 0.3s ease',
            }}
          />
        </>
      )}

      {/* Link Overlay */}
      {showLinkOverlay && (
        <div className="rectangle">
          <a href={linkUrl || '#'} target="_blank" rel="noopener noreferrer">
            <div className="linkPlaceholder" onClick={onPanelToggle} />
          </a>
        </div>
      )}

      {/* Fees Bubble Link */}
      {currentVideo.action?.type === ACTION_TYPES.FEES &&
        !showPanel &&
        showPanelButton && (
          <div className="rectangle">
            <div className="bubbleLink" onClick={onPanelToggle} />
          </div>
        )}

      {/* Panel Button */}
      {currentVideo.action?.type === ACTION_TYPES.PANEL &&
        !showPanel &&
        showPanelButton && (
          <div className="rectangle">
            <div className="linkPlaceholder" onClick={onPanelToggle} />
          </div>
        )}

      {/* Side Panel */}
      {showPanel && (
        <div className="side-panel open">
          <button className="close-btn" onClick={onPanelClose}>
            <CloseIcon style={{ fill: 'gold', width: 24, height: 24 }} />
          </button>
          {panelData === PANEL_VARIANTS.PAMP && (
            <PanelContent type={PANEL_VARIANTS.PAMP} />
          )}
          {panelData === PANEL_VARIANTS.ROYAL_MINT && (
            <PanelContent type={PANEL_VARIANTS.ROYAL_MINT} />
          )}
          {panelData === PANEL_VARIANTS.LLOYDS_INSURANCE && (
            <PanelContent type={PANEL_VARIANTS.LLOYDS_INSURANCE} />
          )}
        </div>
      )}
    </div>
  )
}
